// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    SupportCreateTagPayload,
    SupportCreateTagRecordPayload,
    SupportReplaceTagPayload,
    SupportTag,
    SupportTagRecord,
    SupportTagRecordSortType,
    SupportTagSortType,
    SupportUpdateTagPayload,
    SupportCreateTagPayloadToJSON,
    SupportCreateTagRecordPayloadToJSON,
    SupportReplaceTagPayloadToJSON,
    SupportUpdateTagPayloadToJSON,
    ObjectNoResponseFromJSON,
    SupportTagFromJSON,
    SupportTagRecordFromJSON,
} from '../models';

export interface CreateSupportTagRequest {
    supportCreateTagPayload: SupportCreateTagPayload;
}

export interface CreateSupportTagRecordRequest {
    supportCreateTagRecordPayload: SupportCreateTagRecordPayload;
}

export interface CreateSupportTagRecordDeprecatedRequest {
    tid: string;
    supportCreateTagRecordPayload: SupportCreateTagRecordPayload;
}

export interface DisableSupportTagRequest {
    id: string;
}

export interface DisableSupportTagRecordRequest {
    id: string;
}

export interface DisableSupportTagRecordDeprecatedRequest {
    tid: string;
    rid: string;
}

export interface GetSupportTagRequest {
    id: string;
}

export interface GetSupportTagRecordRequest {
    id: string;
}

export interface GetSupportTagRecordDeprecatedRequest {
    tid: string;
    rid: string;
}

export interface ListSupportTagRecordsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportTagRecordsOrderEnum>;
    filterCreated?: Array<string>;
    filterTagId?: Array<string>;
    filterChargemasterId?: Array<string>;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterProfessionalTemplateId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterInstitutionalTemplateId?: Array<string>;
    filterDentalId?: Array<string>;
    filterDentalTemplateId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterNynf3TemplateId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterTransmissionId?: Array<string>;
    filterClearinghouseId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterMedicalProcedureCodeId?: Array<string>;
    filterProviderId?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterMailId?: Array<string>;
    filterLetterId?: Array<string>;
    filterFaxSendId?: Array<string>;
    filterFaxReceiveId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterMessageId?: Array<string>;
    filterSellerId?: Array<string>;
    filterClearinghouseEraId?: Array<string>;
    filterClearinghouseEraItemId?: Array<string>;
    filterCodingId?: Array<string>;
    filterPhoneId?: Array<string>;
    filterEmailSendId?: Array<string>;
    filterActive?: string;
    filterEligibilityId?: Array<string>;
    sort?: Array<SupportTagRecordSortType>;
}

export interface ListSupportTagRecordsDeprecatedRequest {
    tid: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportTagRecordsDeprecatedOrderEnum>;
    filterCreated?: Array<string>;
    filterChargemasterId?: Array<string>;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterProfessionalTemplateId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterInstitutionalTemplateId?: Array<string>;
    filterDentalId?: Array<string>;
    filterDentalTemplateId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterNynf3TemplateId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterTransmissionId?: Array<string>;
    filterClearinghouseId?: Array<string>;
    filterDocumentId?: Array<string>;
    filterMedicalProcedureCodeId?: Array<string>;
    filterProviderId?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterMailId?: Array<string>;
    filterLetterId?: Array<string>;
    filterFaxSendId?: Array<string>;
    filterFaxReceiveId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterMessageId?: Array<string>;
    filterSellerId?: Array<string>;
    filterClearinghouseEraId?: Array<string>;
    filterClearinghouseEraItemId?: Array<string>;
    filterCodingId?: Array<string>;
    filterPhoneId?: Array<string>;
    filterEmailSendId?: Array<string>;
    filterActive?: string;
    sort?: Array<SupportTagRecordSortType>;
}

export interface ListSupportTagsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportTagsOrderEnum>;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterClaimId?: Array<string>;
    filterActive?: string;
    filterTagType?: Array<string>;
    sort?: Array<SupportTagSortType>;
}

export interface ReplaceSupportTagRequest {
    supportReplaceTagPayload: SupportReplaceTagPayload;
}

export interface UpdateSupportTagRequest {
    id: string;
    supportUpdateTagPayload: SupportUpdateTagPayload;
}

/**
 * no description
 */
export class TagApi extends runtime.BaseAPI {

    /**
     * Create a tag
     * Create a tag
     */
    async createSupportTagRaw(requestParameters: CreateSupportTagRequest): Promise<runtime.ApiResponse<SupportTag>> {
        if (requestParameters['supportCreateTagPayload'] === null || requestParameters['supportCreateTagPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateTagPayload','Required parameter requestParameters.supportCreateTagPayload was null or undefined when calling createSupportTag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateTagPayloadToJSON(requestParameters['supportCreateTagPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagFromJSON(jsonValue));
    }

    /**
     * Create a tag
     * Create a tag
     */
    async createSupportTag(requestParameters: CreateSupportTagRequest): Promise<SupportTag> {
        const response = await this.createSupportTagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a tag record
     * Create a tag record
     */
    async createSupportTagRecordRaw(requestParameters: CreateSupportTagRecordRequest): Promise<runtime.ApiResponse<SupportTagRecord>> {
        if (requestParameters['supportCreateTagRecordPayload'] === null || requestParameters['supportCreateTagRecordPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateTagRecordPayload','Required parameter requestParameters.supportCreateTagRecordPayload was null or undefined when calling createSupportTagRecord.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/record`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateTagRecordPayloadToJSON(requestParameters['supportCreateTagRecordPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagRecordFromJSON(jsonValue));
    }

    /**
     * Create a tag record
     * Create a tag record
     */
    async createSupportTagRecord(requestParameters: CreateSupportTagRecordRequest): Promise<SupportTagRecord> {
        const response = await this.createSupportTagRecordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a tag record
     * Create a tag record
     */
    async createSupportTagRecordDeprecatedRaw(requestParameters: CreateSupportTagRecordDeprecatedRequest): Promise<runtime.ApiResponse<SupportTagRecord>> {
        if (requestParameters['tid'] === null || requestParameters['tid'] === undefined) {
            throw new runtime.RequiredError('tid','Required parameter requestParameters.tid was null or undefined when calling createSupportTagRecordDeprecated.');
        }

        if (requestParameters['supportCreateTagRecordPayload'] === null || requestParameters['supportCreateTagRecordPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateTagRecordPayload','Required parameter requestParameters.supportCreateTagRecordPayload was null or undefined when calling createSupportTagRecordDeprecated.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{tid}/record`.replace(`{${"tid"}}`, encodeURIComponent(String(requestParameters.tid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateTagRecordPayloadToJSON(requestParameters['supportCreateTagRecordPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagRecordFromJSON(jsonValue));
    }

    /**
     * Create a tag record
     * Create a tag record
     */
    async createSupportTagRecordDeprecated(requestParameters: CreateSupportTagRecordDeprecatedRequest): Promise<SupportTagRecord> {
        const response = await this.createSupportTagRecordDeprecatedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a tag
     * Disable a tag
     */
    async disableSupportTagRaw(requestParameters: DisableSupportTagRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportTag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a tag
     * Disable a tag
     */
    async disableSupportTag(requestParameters: DisableSupportTagRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportTagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a tag record
     * Disable a tag record
     */
    async disableSupportTagRecordRaw(requestParameters: DisableSupportTagRecordRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportTagRecord.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/record/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a tag record
     * Disable a tag record
     */
    async disableSupportTagRecord(requestParameters: DisableSupportTagRecordRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportTagRecordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a tag record
     * Disable a tag record
     */
    async disableSupportTagRecordDeprecatedRaw(requestParameters: DisableSupportTagRecordDeprecatedRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['tid'] === null || requestParameters['tid'] === undefined) {
            throw new runtime.RequiredError('tid','Required parameter requestParameters.tid was null or undefined when calling disableSupportTagRecordDeprecated.');
        }

        if (requestParameters['rid'] === null || requestParameters['rid'] === undefined) {
            throw new runtime.RequiredError('rid','Required parameter requestParameters.rid was null or undefined when calling disableSupportTagRecordDeprecated.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{tid}/record/{rid}/disable`.replace(`{${"tid"}}`, encodeURIComponent(String(requestParameters.tid))).replace(`{${"rid"}}`, encodeURIComponent(String(requestParameters.rid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a tag record
     * Disable a tag record
     */
    async disableSupportTagRecordDeprecated(requestParameters: DisableSupportTagRecordDeprecatedRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportTagRecordDeprecatedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a tag
     * Get a tag
     */
    async getSupportTagRaw(requestParameters: GetSupportTagRequest): Promise<runtime.ApiResponse<SupportTag>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportTag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagFromJSON(jsonValue));
    }

    /**
     * Gets a tag
     * Get a tag
     */
    async getSupportTag(requestParameters: GetSupportTagRequest): Promise<SupportTag> {
        const response = await this.getSupportTagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a tag record
     * Get a tag record
     */
    async getSupportTagRecordRaw(requestParameters: GetSupportTagRecordRequest): Promise<runtime.ApiResponse<SupportTagRecord>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportTagRecord.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/record/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagRecordFromJSON(jsonValue));
    }

    /**
     * Gets a tag record
     * Get a tag record
     */
    async getSupportTagRecord(requestParameters: GetSupportTagRecordRequest): Promise<SupportTagRecord> {
        const response = await this.getSupportTagRecordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a tag record
     * Get a tag record
     */
    async getSupportTagRecordDeprecatedRaw(requestParameters: GetSupportTagRecordDeprecatedRequest): Promise<runtime.ApiResponse<SupportTagRecord>> {
        if (requestParameters['tid'] === null || requestParameters['tid'] === undefined) {
            throw new runtime.RequiredError('tid','Required parameter requestParameters.tid was null or undefined when calling getSupportTagRecordDeprecated.');
        }

        if (requestParameters['rid'] === null || requestParameters['rid'] === undefined) {
            throw new runtime.RequiredError('rid','Required parameter requestParameters.rid was null or undefined when calling getSupportTagRecordDeprecated.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{tid}/record/{rid}`.replace(`{${"tid"}}`, encodeURIComponent(String(requestParameters.tid))).replace(`{${"rid"}}`, encodeURIComponent(String(requestParameters.rid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportTagRecordFromJSON(jsonValue));
    }

    /**
     * Gets a tag record
     * Get a tag record
     */
    async getSupportTagRecordDeprecated(requestParameters: GetSupportTagRecordDeprecatedRequest): Promise<SupportTagRecord> {
        const response = await this.getSupportTagRecordDeprecatedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of tag records
     * Get a list of tag records
     */
    async listSupportTagRecordsRaw(requestParameters: ListSupportTagRecordsRequest): Promise<runtime.ApiResponse<Array<SupportTagRecord>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTagId) {
            queryParameters['filterTagId'] = requestParameters.filterTagId;
        }

        if (requestParameters.filterChargemasterId) {
            queryParameters['filterChargemasterId'] = requestParameters.filterChargemasterId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterProfessionalTemplateId) {
            queryParameters['filterProfessionalTemplateId'] = requestParameters.filterProfessionalTemplateId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterInstitutionalTemplateId) {
            queryParameters['filterInstitutionalTemplateId'] = requestParameters.filterInstitutionalTemplateId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterDentalTemplateId) {
            queryParameters['filterDentalTemplateId'] = requestParameters.filterDentalTemplateId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterNynf3TemplateId) {
            queryParameters['filterNynf3TemplateId'] = requestParameters.filterNynf3TemplateId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterTransmissionId) {
            queryParameters['filterTransmissionId'] = requestParameters.filterTransmissionId;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterMedicalProcedureCodeId) {
            queryParameters['filterMedicalProcedureCodeId'] = requestParameters.filterMedicalProcedureCodeId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterMailId) {
            queryParameters['filterMailId'] = requestParameters.filterMailId;
        }

        if (requestParameters.filterLetterId) {
            queryParameters['filterLetterId'] = requestParameters.filterLetterId;
        }

        if (requestParameters.filterFaxSendId) {
            queryParameters['filterFaxSendId'] = requestParameters.filterFaxSendId;
        }

        if (requestParameters.filterFaxReceiveId) {
            queryParameters['filterFaxReceiveId'] = requestParameters.filterFaxReceiveId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterClearinghouseEraId) {
            queryParameters['filterClearinghouseEraId'] = requestParameters.filterClearinghouseEraId;
        }

        if (requestParameters.filterClearinghouseEraItemId) {
            queryParameters['filterClearinghouseEraItemId'] = requestParameters.filterClearinghouseEraItemId;
        }

        if (requestParameters.filterCodingId) {
            queryParameters['filterCodingId'] = requestParameters.filterCodingId;
        }

        if (requestParameters.filterPhoneId) {
            queryParameters['filterPhoneId'] = requestParameters.filterPhoneId;
        }

        if (requestParameters.filterEmailSendId) {
            queryParameters['filterEmailSendId'] = requestParameters.filterEmailSendId;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterEligibilityId) {
            queryParameters['filterEligibilityId'] = requestParameters.filterEligibilityId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/record`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportTagRecordFromJSON));
    }

    /**
     * Gets a list of tag records
     * Get a list of tag records
     */
    async listSupportTagRecords(requestParameters: ListSupportTagRecordsRequest): Promise<Array<SupportTagRecord>> {
        const response = await this.listSupportTagRecordsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of tag records
     * Get a list of tag records
     */
    async listSupportTagRecordsDeprecatedRaw(requestParameters: ListSupportTagRecordsDeprecatedRequest): Promise<runtime.ApiResponse<Array<SupportTagRecord>>> {
        if (requestParameters['tid'] === null || requestParameters['tid'] === undefined) {
            throw new runtime.RequiredError('tid','Required parameter requestParameters.tid was null or undefined when calling listSupportTagRecordsDeprecated.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterChargemasterId) {
            queryParameters['filterChargemasterId'] = requestParameters.filterChargemasterId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterProfessionalTemplateId) {
            queryParameters['filterProfessionalTemplateId'] = requestParameters.filterProfessionalTemplateId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterInstitutionalTemplateId) {
            queryParameters['filterInstitutionalTemplateId'] = requestParameters.filterInstitutionalTemplateId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterDentalTemplateId) {
            queryParameters['filterDentalTemplateId'] = requestParameters.filterDentalTemplateId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterNynf3TemplateId) {
            queryParameters['filterNynf3TemplateId'] = requestParameters.filterNynf3TemplateId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterTransmissionId) {
            queryParameters['filterTransmissionId'] = requestParameters.filterTransmissionId;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.filterDocumentId) {
            queryParameters['filterDocumentId'] = requestParameters.filterDocumentId;
        }

        if (requestParameters.filterMedicalProcedureCodeId) {
            queryParameters['filterMedicalProcedureCodeId'] = requestParameters.filterMedicalProcedureCodeId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterMailId) {
            queryParameters['filterMailId'] = requestParameters.filterMailId;
        }

        if (requestParameters.filterLetterId) {
            queryParameters['filterLetterId'] = requestParameters.filterLetterId;
        }

        if (requestParameters.filterFaxSendId) {
            queryParameters['filterFaxSendId'] = requestParameters.filterFaxSendId;
        }

        if (requestParameters.filterFaxReceiveId) {
            queryParameters['filterFaxReceiveId'] = requestParameters.filterFaxReceiveId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterMessageId) {
            queryParameters['filterMessageId'] = requestParameters.filterMessageId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterClearinghouseEraId) {
            queryParameters['filterClearinghouseEraId'] = requestParameters.filterClearinghouseEraId;
        }

        if (requestParameters.filterClearinghouseEraItemId) {
            queryParameters['filterClearinghouseEraItemId'] = requestParameters.filterClearinghouseEraItemId;
        }

        if (requestParameters.filterCodingId) {
            queryParameters['filterCodingId'] = requestParameters.filterCodingId;
        }

        if (requestParameters.filterPhoneId) {
            queryParameters['filterPhoneId'] = requestParameters.filterPhoneId;
        }

        if (requestParameters.filterEmailSendId) {
            queryParameters['filterEmailSendId'] = requestParameters.filterEmailSendId;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{tid}/record`.replace(`{${"tid"}}`, encodeURIComponent(String(requestParameters.tid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportTagRecordFromJSON));
    }

    /**
     * Gets a list of tag records
     * Get a list of tag records
     */
    async listSupportTagRecordsDeprecated(requestParameters: ListSupportTagRecordsDeprecatedRequest): Promise<Array<SupportTagRecord>> {
        const response = await this.listSupportTagRecordsDeprecatedRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of tags
     * Get a list of tags
     */
    async listSupportTagsRaw(requestParameters: ListSupportTagsRequest): Promise<runtime.ApiResponse<Array<SupportTag>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTagType) {
            queryParameters['filterTagType'] = requestParameters.filterTagType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportTagFromJSON));
    }

    /**
     * Gets a list of tags
     * Get a list of tags
     */
    async listSupportTags(requestParameters: ListSupportTagsRequest): Promise<Array<SupportTag>> {
        const response = await this.listSupportTagsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a tag
     * Replace a tag
     */
    async replaceSupportTagRaw(requestParameters: ReplaceSupportTagRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceTagPayload'] === null || requestParameters['supportReplaceTagPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceTagPayload','Required parameter requestParameters.supportReplaceTagPayload was null or undefined when calling replaceSupportTag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:tag", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceTagPayloadToJSON(requestParameters['supportReplaceTagPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a tag
     * Replace a tag
     */
    async replaceSupportTag(requestParameters: ReplaceSupportTagRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportTagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a tag
     * Update a tag
     */
    async updateSupportTagRaw(requestParameters: UpdateSupportTagRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportTag.');
        }

        if (requestParameters['supportUpdateTagPayload'] === null || requestParameters['supportUpdateTagPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateTagPayload','Required parameter requestParameters.supportUpdateTagPayload was null or undefined when calling updateSupportTag.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:tag", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/tag/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateTagPayloadToJSON(requestParameters['supportUpdateTagPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a tag
     * Update a tag
     */
    async updateSupportTag(requestParameters: UpdateSupportTagRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportTagRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListSupportTagRecordsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportTagRecordsDeprecatedOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportTagsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
